import React from "react";
import { IconProps } from "../icon";

export const Pilcrow_01Icon = ({ size = "24px", color = "#000", ...props }: IconProps<string, string>) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M16 4v16m0-16h2m-2 0h-5.5a4.5 4.5 0 000 9H16V4zm-2 16h4"
    />
  </svg>
);
